import { Outlet } from 'react-router-dom';
import {
  IconNavArchiveBox,
  IconNavHome,
  IconNavPencilSquare,
  IconNavSparkles,
} from '../../components/icons';
import { AppShellGrid, type NavEntry } from '../../components/Sidebar';
import { useDict } from '../../i18n/dictionary';
import { useAppCrumb } from '../../layouts/AppLayout';
import { useLocale } from '../../lib/locale';
import { libraryDict } from './i18n';
import { storiesOf } from './stories';

export function LibraryLayout() {
  const t = useDict(libraryDict);
  const { locale } = useLocale();
  useAppCrumb('library', t.appName, '/library');

  // Entries come from the story registry, so the nav cannot drift from the
  // routes. On a phone the components group is one tab onto their list.
  const components = storiesOf('component', locale).map(({ slug, story }) => ({
    key: slug,
    href: `/library/${slug}`,
    label: story.title[locale],
  }));
  const nav: NavEntry[] = [
    {
      key: 'home',
      href: '/library',
      label: t.home,
      icon: IconNavHome,
      end: true,
    },
    {
      key: 'components',
      href: '/library/components',
      label: t.components,
      icon: IconNavArchiveBox,
      activeOn: components.map((entry) => entry.href),
      children: components,
    },
    {
      key: 'icons',
      href: '/library/icons',
      label: t.icons,
      icon: IconNavSparkles,
    },
    {
      key: 'primitives',
      href: '/library/primitives',
      label: t.primitives,
      icon: IconNavPencilSquare,
    },
  ];
  return (
    <AppShellGrid items={nav}>
      <Outlet />
    </AppShellGrid>
  );
}
